import React from 'react';
import {IOrderModel} from '@src/@interfaces/models/Order/IOrderModel';
import {Props} from '@src/components/Form/FormField';
import {default as Body} from '@views/orders/fields/products/extra_row/operations/LazyBody';

export default function OperationsTab<Model extends IOrderModel = IOrderModel>(props: Props<Model>) {
    if (!props.model?.order_id || !props.model?.id) {
        return null;
    }

    return <Body
            rowId={+props.model?.order_id}
            rowIndex={0}
            orderId={props.model?.order_id}
            productId={props.model.id}
            controllerName="Orders"
            forceDisabled={props.forceDisabled}
            stateContainerProductPath="products.0"
            stateContainerNamePrefix="products.0.operations"
            modelOptions={props.modelOptions}
            isDisplayed
    />;
}
